export const BRAND_LOGO_URL = "https://portofolio-web.s3.ap-northeast-2.amazonaws.com/rv-logo.png";
